import { enqueueSnackbar, UploadFile } from 'actions';

import {
	ImportFileRequest
} from '../requests/ImportRequests.js';

export const ImportFile = (fileLocation) => async (dispatch) => {
	await ImportFileRequest(fileLocation).then(response => {
		dispatch(enqueueSnackbar({ message: 'Files uploaded with success!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const Upload = (file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ImportFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
